// Owner restaurant creation (SFAPI-214).
//
// An owner creates a restaurant through
// POST /api/restaurant_franchises/{franchiseId}/restaurants with a name, an
// optional address, a country and a currency. There is no manager in that
// request: the restaurant starts without one and the owner assigns managers
// afterwards through POST /api/restaurants/{id}/managers (the first one
// becomes the primary manager).

export interface FranchiseRestaurantFormValues {
  name: string;
  address?: string;
  countryId?: string;
  currencyId?: string;
}

export interface CreateFranchiseRestaurantPayload {
  name: string;
  address?: string;
  country: string;
  currency: string;
}

export const buildFranchiseRestaurantPayload = (
  values: FranchiseRestaurantFormValues
): CreateFranchiseRestaurantPayload => {
  const address = values.address?.trim() ?? "";

  return {
    name: values.name.trim(),
    ...(address !== "" ? { address } : {}),
    country: `/api/countries/${values.countryId ?? ""}`,
    currency: `/api/currencies/${values.currencyId ?? ""}`,
  };
};
